// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30ADa","col":"styles_col__F001o"};